import { apiFetch } from '../http';
import type { User } from '../types';

export type LoginInput = { email: string; password: string; turnstile_token: string };
export type RegisterInput = {
  name: string;
  email: string;
  password: string;
  password_confirmation: string;
  company_name: string;
  turnstile_token: string;
};

export const authApi = {
  register: (input: RegisterInput) =>
    apiFetch<{ data: User }>('/api/v1/auth/register', { method: 'POST', body: input }),
  login: (input: LoginInput) => apiFetch<{ data: User }>('/api/v1/auth/login', { method: 'POST', body: input }),
  logout: () => apiFetch<void>('/api/v1/auth/logout', { method: 'POST' }),
  googleRedirect: () => apiFetch<{ data: { url: string } }>('/api/v1/auth/google/redirect'),
  resendVerification: () => apiFetch<void>('/api/v1/auth/email/resend', { method: 'POST' }),
  forgotPassword: (input: { email: string; turnstile_token: string }) =>
    apiFetch<void>('/api/v1/auth/password/forgot', { method: 'POST', body: input }),
  resetPassword: (input: {
    token: string;
    email: string;
    password: string;
    password_confirmation: string;
    turnstile_token: string;
  }) => apiFetch<void>('/api/v1/auth/password/reset', { method: 'POST', body: input }),
};
